'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _zh_CN = require('./zh_CN');

var _zh_CN2 = _interopRequireDefault(_zh_CN);

var _zh_CN_zlb = require('./zh_CN_zlb');

var _zh_CN_zlb2 = _interopRequireDefault(_zh_CN_zlb);

var _en_US_zlb = require('./en_US_zlb');

var _en_US_zlb2 = _interopRequireDefault(_en_US_zlb);

var _en_US = require('./en_US');

var _en_US2 = _interopRequireDefault(_en_US);

var _fr_FR_zlb = require('./fr_FR_zlb');

var _fr_FR_zlb2 = _interopRequireDefault(_fr_FR_zlb);

var _fr_FR_copy = require('./fr_FR_copy');

var _fr_FR_copy2 = _interopRequireDefault(_fr_FR_copy);

var _ar_AR = require('./ar_AR');

var _ar_AR2 = _interopRequireDefault(_ar_AR);

var _ar_AR_zlb = require('./ar_AR_zlb');

var _ar_AR_zlb2 = _interopRequireDefault(_ar_AR_zlb);

var _es_ES = require('./es_ES');

var _es_ES2 = _interopRequireDefault(_es_ES);

var _es_ES_zlb = require('./es_ES_zlb');

var _es_ES_zlb2 = _interopRequireDefault(_es_ES_zlb);

var _id_ID = require('./id_ID');

var _id_ID2 = _interopRequireDefault(_id_ID);

var _id_ID_zlb = require('./id_ID_zlb');

var _id_ID_zlb2 = _interopRequireDefault(_id_ID_zlb);

var _kh_KH = require('./kh_KH');

var _kh_KH2 = _interopRequireDefault(_kh_KH);

var _kh_KH_zlb = require('./kh_KH_zlb');

var _kh_KH_zlb2 = _interopRequireDefault(_kh_KH_zlb);

var _laos_LA = require('./laos_LA');

var _laos_LA2 = _interopRequireDefault(_laos_LA);

var _laos_LA_zlb = require('./laos_LA_zlb');

var _laos_LA_zlb2 = _interopRequireDefault(_laos_LA_zlb);

var _pt_PT = require('./pt_PT');

var _pt_PT2 = _interopRequireDefault(_pt_PT);

var _pt_PT_zlb = require('./pt_PT_zlb');

var _pt_PT_zlb2 = _interopRequireDefault(_pt_PT_zlb);

var _ru_RU = require('./ru_RU');

var _ru_RU2 = _interopRequireDefault(_ru_RU);

var _ru_RU_zlb = require('./ru_RU_zlb');

var _ru_RU_zlb2 = _interopRequireDefault(_ru_RU_zlb);

var _vi_VN = require('./vi_VN');

var _vi_VN2 = _interopRequireDefault(_vi_VN);

var _vi_VN_zlb = require('./vi_VN_zlb');

var _vi_VN_zlb2 = _interopRequireDefault(_vi_VN_zlb);

var _arSA = require('./ar-SA');

var _arSA2 = _interopRequireDefault(_arSA);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  zh_CN: (0, _assign2.default)(_zh_CN2.default, _zh_CN_zlb2.default),
  en_US: (0, _assign2.default)(_en_US2.default, _en_US_zlb2.default),
  fr_FR: (0, _assign2.default)(_fr_FR_copy2.default, _fr_FR_zlb2.default),
  ar_AR: (0, _assign2.default)(_ar_AR2.default, _ar_AR_zlb2.default, _arSA2.default),
  es_ES: (0, _assign2.default)(_es_ES2.default, _es_ES_zlb2.default),
  id_ID: (0, _assign2.default)(_id_ID2.default, _id_ID_zlb2.default),
  kh_KH: (0, _assign2.default)(_kh_KH2.default, _kh_KH_zlb2.default),
  laos_LA: (0, _assign2.default)(_laos_LA2.default, _laos_LA_zlb2.default),
  pt_PT: (0, _assign2.default)(_pt_PT2.default, _pt_PT_zlb2.default),
  ru_RU: (0, _assign2.default)(_ru_RU2.default, _ru_RU_zlb2.default),
  vi_VN: (0, _assign2.default)(_vi_VN2.default, _vi_VN_zlb2.default)
}; /* eslint-disable */